import { Stack } from '@chakra-ui/react'

export default Stack
